export default {
  yourEmailPlaceholder: "Your email address",
  yourPasswordPlaceholder: "Your password",
};
